var _line, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectingLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 9,
    viewBox: "0 0 199 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.6416,
    y1: 4.5,
    x2: 190.101,
    y2: 4.5,
    stroke: "black",
    strokeDasharray: "6 6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.19897,
    cy: 4.5,
    rx: 6.19897,
    ry: 4.5,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.167,
    cy: 4.5,
    rx: 6.19897,
    ry: 4.5,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectingLine);
export default __webpack_public_path__ + "static/media/connecting-line.50d900207d5f54daef864dcdd71cbab1.svg";
export { ForwardRef as ReactComponent };